import { BG, BORDER, CARD, DARK, DIM, MID, RED, css } from "../theme";
import { supabase } from "../lib/supabase";
import { fetchProfile } from "../lib/profileColumns";
import { useState } from "react";

// ─── LOGIN SCREEN ─────────────────────────────────────────────────────────────

function Login({ onLogin }) {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");

  async function handleLogin() {
    if (!email || !password) { setError("Please enter your email and password."); return; }
    setLoading(true);
    setError("");
    const { data, error: authError } = await supabase.auth.signInWithPassword({ email, password });
    if (authError) {
      setError("Incorrect email or password. Please try again.");
      setLoading(false);
      return;
    }
    // Fetch contractor profile to get client_type
    const profile = await fetchProfile(supabase, data.user.id);
    onLogin(data.user, profile);
    setLoading(false);
  }

  return (
    <div className="app-root" style={{ minHeight:"100vh", background:BG, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24 }}>
      <style>{css}</style>

      {/* Logo */}
      <div style={{ marginBottom:40, textAlign:"center" }}>
        <div style={{ fontFamily:"'Lora',serif", fontSize:32, fontWeight:500, color:DARK, letterSpacing:"-0.02em" }}>Canopy</div>
        <div style={{ fontFamily:"'DM Sans',sans-serif", fontSize:10, letterSpacing:"0.14em", color:DIM, textTransform:"uppercase", marginTop:4 }}>Business Intelligence</div>
      </div>

      {/* Card */}
      <div className="r-gate" style={{ width:"100%", maxWidth:400, background:CARD, border:`1px solid ${BORDER}`, borderRadius:8, padding:"36px 40px", boxShadow:"0 4px 24px rgba(44,36,22,0.08)" }}>
        <h2 style={{ fontFamily:"'Lora',serif", fontSize:20, fontWeight:500, color:DARK, marginBottom:6, letterSpacing:"-0.01em" }}>Sign in to your account</h2>
        <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:13, color:DIM, marginBottom:28 }}>Enter your credentials below to access your dashboard.</p>

        {/* Email */}
        <div style={{ marginBottom:16 }}>
          <label style={{ display:"block", fontFamily:"'DM Sans',sans-serif", fontSize:11, fontWeight:500, color:MID, letterSpacing:"0.04em", textTransform:"uppercase", marginBottom:6 }}>Email</label>
          <input
            type="email"
            className="chat-input"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleLogin()}
            placeholder="you@example.com"
            autoFocus
          />
        </div>

        {/* Password */}
        <div style={{ marginBottom:24 }}>
          <label style={{ display:"block", fontFamily:"'DM Sans',sans-serif", fontSize:11, fontWeight:500, color:MID, letterSpacing:"0.04em", textTransform:"uppercase", marginBottom:6 }}>Password</label>
          <input
            type="password"
            className="chat-input"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleLogin()}
            placeholder="••••••••"
          />
        </div>

        {/* Error */}
        {error && (
          <div style={{ marginBottom:16, padding:"10px 14px", borderRadius:4, background:"rgba(140,64,64,0.07)", border:`1px solid rgba(140,64,64,0.2)`, fontFamily:"'DM Sans',sans-serif", fontSize:12, color:RED }}>
            {error}
          </div>
        )}

        {/* Submit */}
        <button
          className="btn act"
          onClick={handleLogin}
          disabled={loading}
          style={{ width:"100%", padding:"12px", fontSize:13, opacity:loading ? 0.6 : 1, letterSpacing:"0.03em" }}
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </div>

      {/* Footer */}
      <div style={{ marginTop:24, fontFamily:"'DM Sans',sans-serif", fontSize:11, color:DIM, textAlign:"center" }}>
        Don't have an account? Contact your Canopy administrator.
      </div>
    </div>
  );
}

export { Login };
